module.exports = __webpack_public_path__ + "media/images/countrysquared/es-6aebe666bf330599127098c6ab016e38.svg";